export class GlueFederatedSetup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "trustedPrincipalArn",
            "baseName": "trustedPrincipalArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataAccessPrincipalArn",
            "baseName": "dataAccessPrincipalArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleName",
            "baseName": "roleName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GlueFederatedSetup.attributeTypeMap;
    }
    constructor() {
    }
}
